import { ListBranchItem } from '../types-store';
import { ListBranchItemWire } from '../types';
import { codeItemToStoreValue } from 'app/infrastructure/data/codes';
import { parseAsDateUTC } from 'app/infrastructure/data/date';

export const mapListBranchItemFromWire = (listBranchItems: ListBranchItemWire[]): ListBranchItem[] =>
  listBranchItems?.map(item => ({
    id: item.personId,
    description: item.name,
    disabled: parseAsDateUTC(item.disabled),
    email: item.emailAddress,
    ...(!!item.subscriberGroup && {
      subscriberGroup: item.subscriberGroup.map(codeItemToStoreValue)
    })
  })) || [] as ListBranchItem[];
